import { useCurrentUser } from "@/provider/currentUser";
import { updateProfile } from "@api/moimAPI";
import { useCallback, useState } from "react";
import * as Styled from "./styled";

const DevProfileSetting = () => {
  const { currentUser, setCurrentUser } = useCurrentUser();
  const [loading, setLoadStatus] = useState(false);
  const [changedUsername, setUsername] = useState("");
  const [enableNameSave, setEnableNameSave] = useState(false);

  const updateProfileHandler = useCallback(async () => {
    setLoadStatus(true);
    try {
      const response = await updateProfile({
        name: changedUsername,
      });
      setCurrentUser(
        response as unknown as Partial<Moim.User.IOriginalUserDatum>,
      );
      setEnableNameSave(false);
    } catch (error) {
      console.error("Failed to update profile:", error);
    } finally {
      setLoadStatus(false);
    }
  }, [changedUsername, setCurrentUser]);

  const handleNameChanged = useCallback(
    (ev: React.ChangeEvent<HTMLInputElement>) => {
      const defaultValue = ev.currentTarget.defaultValue;
      const value = ev.currentTarget.value.trim();
      setUsername(value);

      if (value !== defaultValue) {
        setEnableNameSave(true);
      } else {
        setEnableNameSave(false);
      }
    },
    [],
  );

  const handleSaveName = useCallback(() => {
    if (changedUsername) {
      updateProfileHandler();
    }
  }, [changedUsername]);

  if (!currentUser) {
    return (
      <Styled.Wrapper>
        <div>Dev Profile Setting</div>
        <div>Not Found User</div>
      </Styled.Wrapper>
    );
  }

  return (
    <Styled.Wrapper>
      <div>Dev Profile Setting</div>
      <Styled.ItemBox>
        <label>Username</label>
        <input
          type="text"
          id="name"
          defaultValue={currentUser.name}
          onChange={handleNameChanged}
        />
        <Styled.Button
          disabled={!enableNameSave || loading}
          onClick={handleSaveName}
        >
          {loading ? "저장중..." : "저장"}
        </Styled.Button>
      </Styled.ItemBox>
      <Styled.ItemBox>
        <code
          style={{ display: "block", maxHeight: "520px", overflow: "auto" }}
        >
          <pre>{JSON.stringify(currentUser, null, 2)}</pre>
        </code>
      </Styled.ItemBox>
    </Styled.Wrapper>
  );
};

export default DevProfileSetting;
